import validate from 'validate.js'

const constraints = {
  lessonInput: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
